<div class="row">
  <div class="col-12">
    <!-- title -->

    <magieno-input-text-field
    [advancedFormControl]="childForm.formElements.childName | asAdvancedFormControl"></magieno-input-text-field>

    <magieno-datepicker
    [advancedFormControl]="childForm.formElements.childBirthday | asAdvancedFormControl">
      <i class="fas fa-calendar" calendarIcon></i>
    </magieno-datepicker>

    <magieno-input-text-field
    [advancedFormControl]="childForm.formElements.childSIN | asAdvancedFormControl"></magieno-input-text-field>

    <magieno-boolean-select
    [advancedFormControl]="childForm.formElements.childSharedCustody  | asAdvancedFormControl"></magieno-boolean-select>

    @if (this.childForm.value.childSharedCustody) {
      <div
        class="card">
        <div class="card-body">
          <magieno-input-number-field
          [advancedFormControl]="childForm.formElements.childShareCustodyPercentage | asAdvancedFormControl"></magieno-input-number-field>
          <magieno-input-text-field
          [advancedFormControl]="childForm.formElements.childSharedCustodyComment | asAdvancedFormControl"></magieno-input-text-field>
        </div>
      </div>
    }


    <magieno-boolean-select
    [advancedFormControl]="childForm.formElements.childPostSecondaryStudy  | asAdvancedFormControl"></magieno-boolean-select>

    <magieno-input-number-field
    [advancedFormControl]="childForm.formElements.childEarnedRevenue | asAdvancedFormControl"></magieno-input-number-field>

    <magieno-boolean-select
    [advancedFormControl]="childForm.formElements.childAreChildCareExpenses  | asAdvancedFormControl"></magieno-boolean-select>

    @if (this.childForm.value.childAreChildCareExpenses) {
      <div
        class="card">
        <div class="card-body">
          <magieno-boolean-select
          [advancedFormControl]="childForm.formElements.areChildCPEExpenses  | asAdvancedFormControl"></magieno-boolean-select>
          <magieno-boolean-select
          [advancedFormControl]="childForm.formElements.mainSpouseIsCareExpensesOtherThanCPE  | asAdvancedFormControl"></magieno-boolean-select>
        </div>
      </div>
    }

    <magieno-boolean-select
    [advancedFormControl]="childForm.formElements.areChildArtisticActivity | asAdvancedFormControl"></magieno-boolean-select>

    <magieno-boolean-select
    [advancedFormControl]="childForm.formElements.isHandicapped  | asAdvancedFormControl"></magieno-boolean-select>

  </div>
</div> <!-- / .row -->